// @ts-nocheck

import React from 'react';
import { Provider } from 'react-redux';
import { hydrate } from 'react-dom';
import { BrowserRouter } from 'react-router-dom';

import { IntlProvider, MessageFormatElement } from 'react-intl';
import { Intl } from '@classity-edtech/ui-base';
// import { addLocaleData } from 'react-intl';
// import localeData from 'react-intl/locale-data/fr';

import { CacheProvider } from '@emotion/react';
import { ThemeProvider as MUIThemeProvider } from '@mui/material/styles';
import { ThemeProvider as Emotion10ThemeProvider, CssBaseline } from '@mui/material';
import {
  theme,
  themeWithResponsiveFontSizes,
} from '@classity-edtech/ui-base/dist/style/utils/createTheme';
import getLocaleConfig from '@classity-edtech/localisation-utils';
import '!style-loader!css-loader!sass-loader!../node_modules/@classity-edtech/ui-base/dist/style/fonts.scss';
import createEmotionCache from './utils/createEmotionCache';
import ContextProvider from './contexts';

import { store, makeStore } from './store';
import App from './App';
import SeoContextProvider from './contexts/seoContext';
import { PageContent } from './services/models/seo';

const cache = createEmotionCache();

declare global {
  interface Window {
    __LOCALE__: {
      config: Intl.Props['config'];
      messages: Record<string, string> | Record<string, MessageFormatElement[]>;
      code: 'en' | 'fr';
    };
    __UI_CONFIG__: {
      env: 'test' | 'development' | 'staging' | 'production';
    };
    __PRELOADED_STATE__: any;
    seoPage: PageContent;
  }
}

const windowInit = window;
const clientStore = windowInit.__PRELOADED_STATE__
  ? makeStore(windowInit.__PRELOADED_STATE__)
  : store;

// addLocaleData(localeData);

const locale = getLocaleConfig('en');

hydrate(
  <CacheProvider value={cache}>
    <Emotion10ThemeProvider theme={theme}>
      {/* <MUIThemeProvider theme={themeWithResponsiveFontSizes}> */}
      <CssBaseline enableColorScheme />
      <Provider store={clientStore}>
        <Intl.IntlConfigProvider config={locale.config}>
          <IntlProvider messages={locale.messages as any} locale={locale.config.localeCode}>
            <BrowserRouter>
              <ContextProvider value={windowInit.__UI_CONFIG__}>
                <SeoContextProvider value={windowInit.seoPage}>
                  <App />
                </SeoContextProvider>
              </ContextProvider>
            </BrowserRouter>
          </IntlProvider>
        </Intl.IntlConfigProvider>
      </Provider>
      {/* </MUIThemeProvider> */}
    </Emotion10ThemeProvider>
  </CacheProvider>,
  document.querySelector('#app'),
);
